// Author: Shubham Srivastava
// Env File to use for Production.

export const environment = {
  production: true,
  configType: false,
  apiBaseUrl: 'https://newpg.theworldwidecard.net/v2',
  apiBaseUrl3: 'https://newpg.theworldwidecard.net/v2',
  loginAPIUrl: 'https://newpg.theworldwidecard.net',
  apiBaseUrl2: 'https://xabits.com/app',
  pgAPIUrl: 'https://dev-ob1epin.herokuapp.com/api',
  pgUrlNew: 'https://dev-ob1epin.herokuapp.com',
  pgAPIUrl1: 'https://dev-ob1epin.herokuapp.com/api',
  pgUrlNew1: 'https://dev-ob1epin.herokuapp.com',
  setHeaderToken: true
};
